import React, { useEffect, useState } from "react";
import MarketingLayout from "../components/MarketingLayout";
import { api, formatApiError } from "../lib/api";
import { ArrowUpRight } from "lucide-react";
import { toast } from "sonner";

export default function CoursesPage() {
    const [courses, setCourses] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/courses").then(({ data }) => setCourses(data))
            .catch((e) => toast.error(formatApiError(e)))
            .finally(() => setLoading(false));
    }, []);

    return (
        <MarketingLayout>
            <section className="max-w-7xl mx-auto px-6 md:px-10 pt-24 pb-12">
                <div className="label-caps">Formação IHTP</div>
                <h1 className="font-display text-5xl md:text-6xl text-[#0d1628] mt-6 max-w-3xl leading-[1.05]">
                    Cursos para transformar pessoas e organizações.
                </h1>
                <p className="text-[#52525b] text-lg mt-8 max-w-2xl leading-relaxed">
                    Os nossos cursos são ministrados e inscritos em <a href="https://ihavethepower.net" target="_blank" rel="noreferrer" className="link-underline text-[#0d1628]">ihavethepower.net</a>. Explore o catálogo e prossiga para a plataforma oficial para completar a inscrição.
                </p>
            </section>

            <section className="border-t border-[#e4e4e7]">
                <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
                    {loading ? (
                        <div className="label-caps">A carregar...</div>
                    ) : (
                        <div className="grid md:grid-cols-2 gap-6" data-testid="courses-grid">
                            {courses.map((c) => (
                                <article key={c.id} className="card-flat" data-testid={`course-card-${c.id}`}>
                                    {c.image_url && (
                                        <img src={c.image_url} alt={c.title} className="w-full h-56 object-cover -mx-8 -mt-8 mb-6" style={{ width: "calc(100% + 4rem)" }} />
                                    )}
                                    <div className="flex items-center gap-3 label-caps">
                                        <span>{c.level}</span>
                                        <span>•</span>
                                        <span>{c.duration}</span>
                                    </div>
                                    <h2 className="font-display text-3xl text-[#0d1628] mt-4 leading-tight">{c.title}</h2>
                                    <p className="text-sm text-[#52525b] mt-4 leading-relaxed">{c.short_description}</p>
                                    <a href={c.external_url} target="_blank" rel="noreferrer" className="btn-primary mt-8 inline-flex" data-testid={`course-cta-${c.id}`}>
                                        Inscrever em ihavethepower.net <ArrowUpRight size={16} />
                                    </a>
                                </article>
                            ))}
                        </div>
                    )}
                </div>
            </section>
        </MarketingLayout>
    );
}
